(function () {
  var MODAL_KEY = "perfectFrenchHomeModalDismissed";
  var CHIP_KEY = "perfectFrenchHomeChipHidden";
  var MODAL_DELAY = 4000;
  var CHIP_DELAY = 900;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function isCartPage() {
    var path = (window.location.pathname || "").replace(/\/+$/, "") || "/";
    return path === "/cart" || /\/cart$/.test(path);
  }

  function parseDelay(node, attr, fallback) {
    var raw = node.getAttribute(attr);
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 0) {
      return fallback;
    }
    return n;
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key) === "1";
    } catch (err) {
      return false;
    }
  }

  function storageSet(key) {
    try {
      window.sessionStorage.setItem(key, "1");
    } catch (err) {
      /* ignore */
    }
  }

  function hideNewsletter() {
    var news = document.querySelector("[data-kayer-pl-news]");
    if (!news) return;
    news.setAttribute("hidden", "hidden");
    document.body.classList.remove("kayer-pl-news-open");
  }

  function showChip(chip, delay) {
    if (!chip || storageGet(CHIP_KEY)) return;
    window.setTimeout(function () {
      if (storageGet(CHIP_KEY)) return;
      chip.removeAttribute("hidden");
    }, delay);
  }

  function openModal(modal) {
    hideNewsletter();
    modal.removeAttribute("hidden");
    document.body.classList.add("pf-home-popup-open");
  }

  function closeModal(modal, chip) {
    modal.setAttribute("hidden", "hidden");
    document.body.classList.remove("pf-home-popup-open");
    storageSet(MODAL_KEY);
    showChip(chip, 320);
  }

  ready(function () {
    var modal = document.querySelector("[data-pf-home-popup]");
    var chip = document.querySelector("[data-pf-home-chip]");
    if (!modal || !chip || isCartPage()) {
      return;
    }

    if (storageGet(CHIP_KEY)) {
      return;
    }

    var modalDelay = parseDelay(modal, "data-pf-modal-delay", MODAL_DELAY);
    var chipDelay = parseDelay(chip, "data-pf-chip-delay", CHIP_DELAY);

    modal.querySelectorAll("[data-pf-home-popup-close]").forEach(function (node) {
      node.addEventListener("click", function () {
        closeModal(modal, chip);
      });
    });

    var modalCta = modal.querySelector(".pf-home-popup__cta");
    if (modalCta) {
      modalCta.addEventListener("click", function () {
        storageSet(MODAL_KEY);
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hasAttribute("hidden")) {
        closeModal(modal, chip);
      }
    });

    var chipClose = chip.querySelector("[data-pf-home-chip-close]");
    if (chipClose) {
      chipClose.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        chip.setAttribute("hidden", "hidden");
        storageSet(CHIP_KEY);
      });
    }

    if (storageGet(MODAL_KEY)) {
      showChip(chip, chipDelay);
      return;
    }

    window.setTimeout(function () {
      if (storageGet(MODAL_KEY) || storageGet(CHIP_KEY)) return;
      openModal(modal);
    }, modalDelay);
  });
})();
